



























































import {Component, Mixins, Watch} from "vue-property-decorator";
import XDialog from "../SimpleDialog.vue";
import {mapGetters, mapMutations} from "vuex";
import AppApiMixin from "@/components/mixins/AppApi.vue";

@Component({
  components: { XDialog },
  computed: {
    ...mapGetters("stackCaptcha", {
      showCaptcha: "showCaptcha",
      idCaptcha: "idCaptcha",
    }),
  },
  methods: {
    ...mapMutations("stackCaptcha", {
      setShowCaptcha: "setShowCaptcha",
      setIdCaptcha: "setIdCaptcha",
      setConfirmCaptcha: "setConfirmCaptcha",
      setValueCaptcha: "setValueCaptcha",
    }),
  },
})
class StackCaptcha extends Mixins(AppApiMixin) {
  imageLoading = true;

  value: string = "";

  error: string = "";

  async refreshCaptcha() {
    try {
      const result = await this.refreshCaptchaCode(this.idCaptcha);
      this.setIdCaptcha(result.idCaptcha);
    } catch (e) {
      this.error = e;
    }
  }

  mounted() {
    this.setShowCaptcha();
    this.setIdCaptcha();
  }

  @Watch("showCaptcha")
  showCaptchaChanged(val) {
    if (val) {
      // при открытии очистка
      this.value = "";
      this.error = "";
    }
  }

  get image() {
    if (this.idCaptcha == "") {
      return null;
    }
    return (process.env && process.env.VUE_APP_API_URL) + `/captcha/image?idCaptcha=${this.idCaptcha}`;
  }

  fieldRule() {
    return [
      v => !!v || "Заполните данное поле",
    ];
  }
}

export default StackCaptcha;
